import getURLSearchParam from '../base/url'

export default function (target: string) {
  // SSO 请求不经过 mock，总是走真实 API
  if (target.includes('/user/api/v1/sso')) {
    return target
  }

  if (!process.env.VUE_APP_APPMOCK && getURLSearchParam('_mock_') !== '0__0') return target
  const url = new URL(target)
  return (
    'https://appmock.sankuai.com' +
    url.pathname +
    (url.search ? url.search + '&' : '?') +
    'MKOriginHost=' +
    url.host +
    '&MKScheme=' +
    (url.protocol === 'https:' ? 'https' : 'http')
  )
}
